module.exports = "<div class=\"fc-chart\" [id]=\"fcId\"></div>\r\n"